module.exports = __webpack_public_path__ + "static/img/bgjd.1a9cc010.png";